import _camelCase from 'lodash/camelCase';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  reservations: {
    items: [],
    count: 0,
  },
  activeReservations: {
    count: 0,
    items: [],
  },
  historyReservations: {
    count: 0,
    items: [],
  },
  reservationsCount: 0, //for search, part of History
  foundReservations: {
    //for search, part of History
    count: null,
    items: [],
  },
};

const updateReservationsData = (
  { statusType, count, items, resetPagination, isExpandedProductReservationsEnabled },
  state,
) => {
  const storeKey = isExpandedProductReservationsEnabled ? `${_camelCase(statusType)}Reservations` : 'reservations';
  const currentItems = state[storeKey]?.items || [];

  return {
    [storeKey]: {
      count,
      items: resetPagination ? items : [...currentItems, ...items],
    },
  };
};

export const reservationsList = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_RESERVATIONS_ITEMS_LOADING:
    case actionTypes.RESERVATIONS_SEARCH_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_RESERVATIONS_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...updateReservationsData(payload, state),
      };
    case actionTypes.GET_RESERVATIONS_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.RESERVATIONS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundReservations: {
          count: payload.count,
          items: [...state.foundReservations.items, ...payload.items],
        },
      };
    case actionTypes.RESERVATIONS_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.RESERVATIONS_SEARCH_CLEAR:
      return {
        ...state,
        loading: false,
        foundReservations: {
          ...INITIAL_STATE.foundReservations,
        },
      };
    case actionTypes.CLEAR_RESERVATIONS_ITEMS:
      return {
        ...state,
        loading: false,
        reservations: {
          ...INITIAL_STATE.reservations,
        },
        activeReservations: {
          ...INITIAL_STATE.activeReservations,
        },
        historyReservations: {
          ...INITIAL_STATE.historyReservations,
        },
      };
    default:
      return state;
  }
};

export default reservationsList;
